import { Button, Collapse, message, Select, Popover, Input } from 'antd'
import styles from './index.module.scss'
import { useCallback, useContext, useRef, useMemo, useState, useEffect } from 'react'
import InputImageUploader from './components/InputImageUploader'
import ReferSelectionTrigger from './components/ReferSelectionTrigger'
import { AppContext } from '@utils/AppContext';
import GenerateMode from './components/GenerateMode'
import SkinRefine from './components/SkinRefine'
import Relight from './components/Relight'
import SegmentedWarp from './components/SegmentedWarp'
import CustomBkgMode from './components/CustomBkgMode'
import ReferSelectionDrawer from './components/ReferSelectionDrawer';
import PSAIModal from '@PSAIComponents/PSAIModal'
import { GenerateContext } from '../hooks/GenerateContext'
import { RESOURCE_TYPE, IMAGE_TYPE, PRIVATE_ABILITIES, RESOURCE_PARAMS, COMMODITY_SCENE_MODE, GENERATE_MODE, CLOTH_COLOR_TYPE, POSE_FANTASY_MODE } from '@utils/CONST'
import ResolutionSelectionWrap from './components/ResolutionSelectionWrap'
import StrengthSlider from "./components/StrengthSlider"
import SelectGenerateResolution from "./components/SelectGenerateResolution"
import ColorSelection from "./components/ColorSelection"
import ColorPalette from './components/ColorPalette'
import UploadCustomMaterial from './components/UploadCustomMaterial'
import { workflowOfGenerate, generateDisabled } from '@utils/workflowOfBuildTaskV2'
import { RightOutlined, InfoCircleOutlined, LeftOutlined } from '@ant-design/icons';
import Utils from '@utils/utils';
import MattingOptGlasses from '@view/compoents/MattingOpt/MattingOptGlasses';
import MattingOptSimTryon from '@view/compoents/MattingOpt/MattingOptSimTryon';
import API, { commonApiInvoker } from '@api/api';
import eventBus from '@utils/eventBus'
import ImgToVideoParams from './components/ImgToVideoParams'
import PosetryonPrompt from './components/PosetryonPrompt'


const LeftComp = (props) => {
    const {
        hasPrivateAbility, setSelectedTaskListId,
        globalUser, globalOrgInfo
    } = useContext(AppContext);
    const generateContext = useContext(GenerateContext)
    const {
        setProjectId,
        imageType,

        tryonModelKeyList, setTryonModelKeyList,
        poseTryonKeyList, setPoseTryonKeyList,
        glassesTryonKeyList, setGlassesTryonKeyList,
        simTryonKeyList, setSimTryonKeyList,
        modelKeyList, setModelKeyList,
        sceneKeyList, setSceneKeyList,
        shoesKeyList, setShoesKeyList,
        videoKeyList, setVideoKeyList,
        colorKeyList, setColorKeyList,
        setRefImgConfig,

        generateNum, setGenerateNum,

        inputImageLoading, setInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
        getMultiSemanticOutput,
        getSemanticSimTryonMaskId,
        getSemanticSimTryonMaskIdClothTypeAll,
        inputImageClothType,
        generateMode,
        clothColorKeyList, setClothColorKeyList,
        currentClothColorType, setCurrentClothColorType,
        currentPoseFantasyMode, setCurrentPoseFantasyMode,
        prompt, setPrompt,
        duration,
        prompts
    } = generateContext
    const bottomRef = useRef()
    // 调色盘open
    const [colorPaletteOpen, setColorPaletteOpen] = useState(false)
    // drawer open
    const [open, setOpen] = useState(false)
    // 抽屉默认选中的tab
    const [defaultActiveKey, setDefaultActiveKey] = useState()
    // 抽屉自定义上传禁用   
    const [customDisabled, setCustomDisabled] = useState(false)
    // 参考图类型
    const [resourceType, setResourceType] = useState(RESOURCE_TYPE.TRYON_MODEL)
    // 显示分辨率
    const showResolution = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITY
    }, [imageType])
    const showImgToVideoParams = useMemo(() => {
        return imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.MODEL_VIDEO
    }, [imageType])
    const getMultiple = (type) => {
        if (type == RESOURCE_TYPE.TRYON_MODEL) return true
        if (type == RESOURCE_TYPE.POSE_TRYON) return true
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return false
        if (type == RESOURCE_TYPE.SIM_TRYON) return false
        if (type == RESOURCE_TYPE.MODEL) return false
        if (type == RESOURCE_TYPE.TRYON_SCENE) return false
        if (type == RESOURCE_TYPE.TRYON_SHOES) return true
        if (type == RESOURCE_TYPE.COMMODITY_COLOR) return false
        if (type == RESOURCE_TYPE.CLOTH_RECOLOR) return false
        return false
    }
    // 抽屉是否多选
    const multiple = useMemo(() => {
        return getMultiple(resourceType)
    }, [resourceType])
    // 抽屉value
    const drawerValue = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.TRYON_MODEL) return tryonModelKeyList
        if (resourceType == RESOURCE_TYPE.POSE_TRYON) return poseTryonKeyList
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON) return glassesTryonKeyList
        if (resourceType == RESOURCE_TYPE.SIM_TRYON) return simTryonKeyList
        if (resourceType == RESOURCE_TYPE.MODEL) return modelKeyList
        if (resourceType == RESOURCE_TYPE.TRYON_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.MODEL_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.TRYON_SHOES) return shoesKeyList
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) return videoKeyList
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR) return colorKeyList
        if (resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) return clothColorKeyList
    }, [resourceType,
        tryonModelKeyList,
        poseTryonKeyList,
        modelKeyList,
        sceneKeyList,
        shoesKeyList,
        videoKeyList,
        colorKeyList,
        clothColorKeyList,
        glassesTryonKeyList,
        simTryonKeyList])
    // 抽屉change
    const getChangeFunc = (type) => {
        if (type == RESOURCE_TYPE.TRYON_MODEL) return setTryonModelKeyList
        if (type == RESOURCE_TYPE.POSE_TRYON) return setPoseTryonKeyList
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return setGlassesTryonKeyList
        if (type == RESOURCE_TYPE.SIM_TRYON) return setSimTryonKeyList
        if (type == RESOURCE_TYPE.MODEL) return setModelKeyList
        if (type == RESOURCE_TYPE.TRYON_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.MODEL_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.TRYON_SHOES) return setShoesKeyList
        if (type == RESOURCE_TYPE.VIDEO_MODEL) return setVideoKeyList
        if (type == RESOURCE_TYPE.COMMODITY_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.COMMODITY_COLOR) return setColorKeyList
        if (type == RESOURCE_TYPE.CLOTH_RECOLOR) return setClothColorKeyList
    }
    const drawerOnChange = useCallback((value, refImgConfig) => {
        const onChange = getChangeFunc(resourceType)
        onChange?.(value)
        setRefImgConfig(refImgConfig)
    }, [resourceType])
    // 显示生成模式
    const showGenerateMode = useMemo(() => {
        return imageType == IMAGE_TYPE.CLOTHES ||
            imageType == IMAGE_TYPE.SHOES ||
            imageType == IMAGE_TYPE.GRASS_PLANT ||
            imageType == IMAGE_TYPE.GLASSES_TRYON || 
            imageType == IMAGE_TYPE.POSE_TRYON || 
            imageType == IMAGE_TYPE.COMMODITY || 
            imageType == IMAGE_TYPE.COMMODITYRECOLOR
    }, [imageType])
    // 显示人像皮肤优化
    const showSkinRefine = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL
    }, [imageType])
    // 显示光影融合
    const showRelight = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND
    }, [imageType])
    // 显示自定义背景模式
    const showCustomBkgMode = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL &&
            sceneKeyList.find(item => item.custom)
    }, [imageType, sceneKeyList])
    // 显示输出图分辨率选择
    const showGenerateResolution = useMemo(() => {
        return (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) && sceneKeyList.length > 0
    }, [imageType, sceneKeyList])
    // 显示相似度滑块
    const showStrengthSlider = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITY && sceneKeyList.find(item => item.custom)
    }, [imageType, sceneKeyList])
    const showColorSelection = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITYRECOLOR
    }, [imageType])
    // 显示服饰换色颜色选择
    const showClothColorSelection = useMemo(() => {
        return imageType == IMAGE_TYPE.CLOTH_RECOLOR
    }, [imageType])
    const showNumSelect = useMemo(() => {
        return imageType != IMAGE_TYPE.MODEL_VIDEO && imageType != IMAGE_TYPE.IMAGE_TO_VIDEO
    }, [imageType])
    // 删除参考图
    const handleRemove = (resourceType) => {
        PSAIModal.confirm({
            title: `确定删除所选${resourceType == RESOURCE_TYPE.VIDEO_MODEL ? '参考视频' : '参考图'}？`,
            onOk() {
                const onChange = getChangeFunc(resourceType)
                onChange?.([])
            },
            onCancel() { },
        })
    }

    // 保存素材mask
    const saveMaterialPreference = (mask, item, semanticSimTryonMaskId, semanticSimTryonMaskId2) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        commonApiInvoker(API.saveMaterialPreference({
            ...params,
            attr: {
                refMask: mask.binaryMask,
                foregroundAlphaMask: mask.foregroundAlphaMask,
                foregroundMask: mask.foregroundMask,
                semanticSimTryonMaskId,
                semanticSimTryonMaskId2,
            },
            key: item?.key,
            custom: !!item?.custom,
        })).then(res => {
            console.log('saveMaterialPreference')
            // 更新素材列表
            eventBus.emit('updateCustomMaterial')
            // 更新已选中的glassesTryonKeyList
            const setUpdateList = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? setGlassesTryonKeyList :
                resourceType == RESOURCE_TYPE.SIM_TRYON ? setSimTryonKeyList : null
            setUpdateList(prevList => {
                const updatedList = prevList.map(prevItem => {
                    if (prevItem.key === item.key) {
                        return {
                            ...prevItem,
                            attr: {
                                ...prevItem.attr,
                                refMask: mask.binaryMask,
                                foregroundAlphaMask: mask.foregroundAlphaMask,
                                foregroundMask: mask.foregroundMask,
                            }
                        };
                    }
                    return prevItem;
                });
                return updatedList;
            });
        })
    }
    // 打开眼镜/同版型mask弹窗
    const onGlassesMattingOpt = async (item, semanticMaskId = null, semanticMaskId2 = null) => {
        let binaryMask, foregroundAlphaMask, foregroundMask, inputImage
        inputImage = item?.url || ''
        binaryMask = item?.attr?.refMask || ''
        foregroundAlphaMask = item?.attr?.foregroundAlphaMask || ''
        foregroundMask = item?.attr?.foregroundMask || ''
        // 发起抠图优化
        handleMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            semanticMaskId,
            semanticMaskId2,
        }], resList => {
            const res = resList[0]
            if (!res) return
            saveMaterialPreference(res, item, semanticMaskId, semanticMaskId2)
        })
    }
    // 编辑素材mask
    const handleEditMask = async () => {
        const item = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? glassesTryonKeyList[0] :
            resourceType == RESOURCE_TYPE.SIM_TRYON ? simTryonKeyList[0] :
                null
        console.log('item?--------------', item)
        if (!item) return
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON) {
            await onGlassesMattingOpt(item)
        } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
            const semanticSimTryonMaskId = item?.attr?.semanticSimTryonMaskId
            const semanticSimTryonMaskId2 = item?.attr?.semanticSimTryonMaskId2 // 全label分割结果
            if (semanticSimTryonMaskId) {
                await onGlassesMattingOpt(item, semanticSimTryonMaskId, semanticSimTryonMaskId2)
                return
            } else {
                const res = await getSemanticSimTryonMaskId(item?.url)
                const ids = res.split(":")
                const semanticMaskId = ids[1]

                const res2 = await getSemanticSimTryonMaskIdClothTypeAll(item?.imageUrl)
                const ids2 = res2.split(":")
                const semanticMaskId2 = ids2[1]
                await onGlassesMattingOpt(item, semanticMaskId, semanticMaskId2)
            }
        }
    }

    const optFactory = (resourceType, imageType) => {
        const value = resourceType == RESOURCE_TYPE.TRYON_MODEL ? tryonModelKeyList :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? poseTryonKeyList :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? glassesTryonKeyList :
                    resourceType == RESOURCE_TYPE.SIM_TRYON ? simTryonKeyList :
                        resourceType == RESOURCE_TYPE.MODEL ? modelKeyList :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? sceneKeyList :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? sceneKeyList :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? shoesKeyList :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? videoKeyList :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? sceneKeyList :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? colorKeyList :
                                                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? clothColorKeyList :
                                                        []
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "选择参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "选择参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "选择参考图" :
                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "选择颜色" :
                        resourceType == RESOURCE_TYPE.SIM_TRYON ? "选择参考图" :
                            resourceType == RESOURCE_TYPE.MODEL ? "选择模特" :
                                resourceType == RESOURCE_TYPE.MODEL_SCENE ? "选择背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SCENE ? "选择背景" :
                                        resourceType == RESOURCE_TYPE.TRYON_SHOES ? "选择参考图" :
                                            resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "选择视频" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "选择参考图" :
                                                    resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "选择颜色" :
                                                        ""
        const triggerUploadText = resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "点击/拖拽上传" :
            (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ? "点击上传" :
                (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.TRYON_SCENE) ? "点击/拖拽上传" :
                    resourceType == RESOURCE_TYPE.MODEL ? "点击上传" :
                        "点击/拖拽上传"

        const dragTips = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "释放鼠标上传参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "释放鼠标上传参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "释放鼠标上传参考图" :
                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "释放鼠标上传颜色" :
                        resourceType == RESOURCE_TYPE.SIM_TRYON ? "释放鼠标上传参考图" :
                            resourceType == RESOURCE_TYPE.MODEL ? "释放鼠标上传模特" :
                                resourceType == RESOURCE_TYPE.MODEL_SCENE ? "释放鼠标上传背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SCENE ? "释放鼠标上传背景" :
                                        resourceType == RESOURCE_TYPE.TRYON_SHOES ? "释放鼠标上传参考图" :
                                            resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "释放鼠标上传动作" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "释放鼠标上传背景" :
                                                    resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "释放鼠标上传颜色" :
                                                        ""
        const customDisabled = (resourceType == RESOURCE_TYPE.VIDEO_MODEL && !hasPrivateAbility(PRIVATE_ABILITIES.VIDEO_TRYON_DIY_KEY))
        // const vipOnly = resourceType == RESOURCE_TYPE.VIDEO_MODEL 
        // 上传多个
        const uploadMultiple = resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? false :
            true
        return {
            key: resourceType,
            resourceType,
            multiple: getMultiple(resourceType),
            uploadMultiple,
            value,
            // vipOnly, 、// vip图标
            triggerText,
            triggerUploadText,
            dragTips,
            customDisabled,
            onClick: key => {
                handelOpenDrawer(key, resourceType, customDisabled)
            },
            onSecondaryClick: key => {
                if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) {
                    setColorPaletteOpen(true)
                } else {
                    handelOpenDrawer(key, resourceType, customDisabled)
                }
            },
            onUpload: file => handleUpload(file, resourceType, resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? COMMODITY_SCENE_MODE.SIMILAR_STYLE : null), //第三个参数固定写死成原相似风格，可移除
            onRemove: () => handleRemove(resourceType),
            onEditMask: () => handleEditMask()
        }
    }

    // 选择器
    const items = imageType == IMAGE_TYPE.CLOTHES ?
        [{
            key: RESOURCE_TYPE.TRYON_MODEL,
            label: <div>试衣参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_MODEL, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.TRYON_MODEL, imageType)?.value?.length > 0,
        }, {
            key: RESOURCE_TYPE.MODEL,
            label: <div>模特<span style={{ color: "var(--gray-middgray)" }}>（可选）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL, imageType)} />,
            showArrow: true,
            defaultActive: optFactory(RESOURCE_TYPE.MODEL, imageType)?.value?.length > 0,
        }, {
            key: RESOURCE_TYPE.TRYON_SCENE,
            label: <div>背景<span style={{ color: "var(--gray-middgray)" }}>（可选）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_SCENE, imageType)} />,
            showArrow: true,
            defaultActive: optFactory(RESOURCE_TYPE.TRYON_SCENE, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.POSE_TRYON ? (
            currentPoseFantasyMode == POSE_FANTASY_MODE.REFERENCEMODE ? [{
                key: RESOURCE_TYPE.POSE_TRYON,
                label: <div>姿势参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.POSE_TRYON, imageType)} />,
                showArrow: false,
                defaultActive: optFactory(RESOURCE_TYPE.POSE_TRYON, imageType)?.value?.length > 0,
            }] : [{
                key: RESOURCE_TYPE.POSE_TRYON,
                label: <div className={styles.Title}>
                    <div>姿势描述</div>
                    <p className={styles.Template}
                        onClick={open ? () => setOpen(false) : () => handelOpenDrawer("prompt", RESOURCE_TYPE.POSTRYON_PROMPT)}
                    >描述模版 {open ? <LeftOutlined /> : <RightOutlined />}</p>
                </div>,
                children: <PosetryonPrompt />,
                showArrow: false,
            }]
        ) : imageType == IMAGE_TYPE.GLASSES_TRYON ? [{
            key: RESOURCE_TYPE.GLASSES_TRYON,
            label: <div>试戴参考图</div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.GLASSES_TRYON, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.GLASSES_TRYON, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.SIM_TRYON ? [{
            key: RESOURCE_TYPE.SIM_TRYON,
            label: <div>同版型参考图</div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.SIM_TRYON, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.SIM_TRYON, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.MODEL ?
            [{
                key: RESOURCE_TYPE.MODEL,
                label: "模特",
                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL, imageType)} />,
                showArrow: true,
                defaultActive: true,
            }, {
                key: RESOURCE_TYPE.MODEL_SCENE,
                label: <div>背景<span style={{ color: "var(--gray-middgray)" }}>（可选）</span></div>,
                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL_SCENE, imageType)} />,
                showArrow: true,
                defaultActive: sceneKeyList.length > 0,
            }] :
            imageType == IMAGE_TYPE.BACKGROUND ?
                [{
                    key: RESOURCE_TYPE.MODEL_SCENE,
                    label: <div>背景</div>,
                    children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL_SCENE, imageType)} />,
                    showArrow: true,
                    defaultActive: true,
                }] :
                imageType == IMAGE_TYPE.SHOES ?
                    [{
                        key: RESOURCE_TYPE.TRYON_SHOES,
                        label: <div>试鞋参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
                        children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_SHOES, imageType)} />,
                        showArrow: false,
                        defaultActive: optFactory(RESOURCE_TYPE.TRYON_SHOES, imageType)?.value?.length > 0,
                    }] :
                    imageType == IMAGE_TYPE.MODEL_VIDEO ?
                        [{
                            key: RESOURCE_TYPE.VIDEO_MODEL,
                            label: "参考视频",
                            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.VIDEO_MODEL, imageType)} />,
                            showArrow: false,
                            defaultActive: optFactory(RESOURCE_TYPE.VIDEO_MODEL, imageType)?.value?.length > 0,
                        }] :
                        imageType == IMAGE_TYPE.COMMODITY ?
                            [{
                                key: RESOURCE_TYPE.COMMODITY_SCENE,
                                label: <p>背景参考图 <span style={{ color: '#96A2B1', marginLeft: '8px' }}>请上传空场景</span></p>,
                                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.COMMODITY_SCENE, imageType)} />,
                                showArrow: false,
                                defaultActive: optFactory(RESOURCE_TYPE.COMMODITY_SCENE, imageType)?.value?.length > 0,
                            }] :
                            imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                                [{
                                    key: RESOURCE_TYPE.COMMODITY_COLOR,
                                    label: "目标颜色",
                                    children: (
                                        <ColorPalette
                                            value={colorKeyList[0]}
                                            onChange={color => setColorKeyList([color])}
                                            open={colorPaletteOpen}
                                            onOpenChange={setColorPaletteOpen}
                                        >
                                            <div>
                                                <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.COMMODITY_COLOR, imageType)} />
                                            </div>
                                        </ColorPalette>
                                    ),
                                    showArrow: false,
                                }] : imageType == IMAGE_TYPE.CLOTH_RECOLOR ?
                                    [{
                                        key: RESOURCE_TYPE.CLOTH_RECOLOR,
                                        label: "目标颜色",
                                        children: (
                                            <ColorPalette
                                                value={clothColorKeyList[0]}
                                                onChange={color => setClothColorKeyList([color])}
                                                open={colorPaletteOpen}
                                                onOpenChange={setColorPaletteOpen}
                                            >
                                                <div>
                                                    <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.CLOTH_RECOLOR, imageType)} />
                                                </div>
                                            </ColorPalette>
                                        ),
                                        showArrow: false,
                                    }] : []
    // 选中的collapse
    const [value, setValue] = useState(items.filter(item => !item.showArrow || item.defaultActive).map(item => item.key));
    // 切换collapse
    const handleCollapseChange = (value) => {
        // 包含所有元素且不重复
        const containsAllElementsWithoutDuplicates = (A, B) => {
            const setA = new Set(A);
            return B.every(item => setA.has(item));
        }
        const notCollapseKeys = items.filter(item => !item.showArrow).map(item => item.key)
        if (containsAllElementsWithoutDuplicates(value, notCollapseKeys)) {
            setValue(value);
        } else {
            setValue([...notCollapseKeys, ...value])
        }
    };
    // 打开抽屉
    const handelOpenDrawer = (defaultActiveKey, resourceType, customDisabled = false) => {
        console.log('defaultActiveKey', defaultActiveKey)
        setOpen(true)
        setResourceType(resourceType)
        setDefaultActiveKey(defaultActiveKey)
        setCustomDisabled(customDisabled)
    }

    // 兼容眼镜试戴、同版型试衣时，直接赋值resourceType，便于保存涂抹素材mask后判断逻辑
    useEffect(() => {
        if (imageType != IMAGE_TYPE.GLASSES_TRYON && imageType != IMAGE_TYPE.SIM_TRYON) return
        setResourceType(imageType)
    }, [imageType])


    // 生成
    const [loading, setLoading] = useState(false)
    const handleGenerate = async () => {
        try {
            // 需要登录
            const status = Utils.checkLoginStatus(() => handleGenerate())
            if (!status) return

            // 视频需仅支持付费用户
            if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.MODEL_VIDEO) {
                const isPaidUser = globalUser?.membership?.level !== 0
                if (!isPaidUser) {
                    message.warning('视频生成需要付费用户或者企业版用户')
                    eventBus.emit('recharge')
                    return
                }
            }

            setLoading(true)
            // 关闭抽屉
            setOpen(false)
            // 检查生成参数是否齐全
            if (generateDisabled(imageType, generateContext) || isLoading) return
            const projectId = await workflowOfGenerate(imageType, generateContext, {
                projectId: generateContext.projectId
            })
            if (!projectId) return
            setSelectedTaskListId(projectId)
            setProjectId(projectId)
            message.success("生成中，请稍等片刻")
            props.createClick()
        } catch (err) {
            console.log(err)
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    // 上传自定义素材
    const uploadCustomMaterialRef = useRef()
    const handleUpload = (...args) => {
        return uploadCustomMaterialRef.current?.doUpload(...args)
    }
    // 选择张数
    const selectedNum = useMemo(() => {
        let num = 1
        if (imageType == IMAGE_TYPE.CLOTHES) {
            num = tryonModelKeyList.length
        } else if (imageType == IMAGE_TYPE.SHOES) {
            num = shoesKeyList.length
        } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
            if (currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
                num = prompts.filter(item => item).length
            } else {
                num = poseTryonKeyList.length
            }
        }
        return Math.max(num, 1)
    }, [imageType, tryonModelKeyList, shoesKeyList, poseTryonKeyList, currentPoseFantasyMode, prompts])
    // 虹豆消耗：衣服图10/张；其他10/张；视频80
    const costBean = useMemo(() => {
        // console.log('imageType', imageType)
        let unitPrice = generateMode == GENERATE_MODE.STD ? 10 : 15
        let totalNum = generateNum * selectedNum
        if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            unitPrice = (Math.round(videoKeyList?.[0]?.attr?.duration / 1000) || 0) * (generateMode == GENERATE_MODE.STD ? 25 : 40)
        }
        if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            unitPrice = generateMode == GENERATE_MODE.STD ? (duration == 5 ? 110 : 220) : (duration == 5 ? 200 : 400)
        }
        return totalNum * unitPrice
    }, [imageType, selectedNum, generateNum, generateMode, duration, videoKeyList])
    // 展开箭头方向
    const expandIcon = (props) => {
        return <RightOutlined rotate={props.isActive ? -90 : 90} />
    }
    // 生成数量显示
    // 能多选参考图的，默认状态下显示4张，选择1张后再显示*1
    const labelRender = props => {
        let num = 1
        let showNum = false
        if (imageType == IMAGE_TYPE.CLOTHES) {
            num = tryonModelKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.SHOES) {
            num = shoesKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.REFERENCEMODE) {
            num = poseTryonKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
            num = prompts.filter(item => item).length
            if (!num) showNum = false
            else showNum = true
        }
        return showNum ? `${props.label} * ${selectedNum}` : props.label
    }

    const isLoading = useMemo(() => {
        return inputImageLoading ||
            topInputImageLoading ||
            bottomInputImageLoading ||
            no1MultiAngleImageLoading ||
            no2MultiAngleImageLoading
    }, [
        inputImageLoading,
        topInputImageLoading,
        bottomInputImageLoading,
        no1MultiAngleImageLoading,
        no2MultiAngleImageLoading,
    ])

    // 素材涂抹弹窗
    const [mattingOptOpen, setMattingOptOpen] = useState(false)
    const [mattingOptGroups, setMattingOptGroups] = useState([])
    const [mattingOptIndex, setMattingOptIndex] = useState(0)
    const [mattingOptLoading, setMattingOptLoading] = useState(false)
    const mattingOptRefs = useRef([])
    const mattingOptCallback = useRef(null)

    const handleMattingOpt = (current, groups, callback) => {
        console.log('groups', groups)
        setMattingOptOpen(true)
        setMattingOptGroups(groups)
        setMattingOptIndex(current)
        mattingOptCallback.current = callback
    }

    const handleMattingOptSave = async () => {
        setMattingOptLoading(true)
        const resList = []
        for (let ref of mattingOptRefs.current) {
            const changed = await ref.saveHandle();
            console.log('changed', changed)
            if (changed) {
                const { blueMask, whiteMask, blendedImage } = changed;
                const blendedImageUrl = await Utils.uploadBase64Image(blendedImage)
                resList.push({
                    binaryMask: whiteMask,
                    foregroundAlphaMask: blueMask,
                    foregroundMask: blendedImageUrl,
                })
            } else {
                setMattingOptLoading(false)
                message.error('请先在原图上标记出要替换的区域！', 5)
                return
                console.log('no change')
                resList.push(null)
            }
        }
        if (mattingOptCallback.current) {
            await mattingOptCallback.current(resList)
            mattingOptCallback.current = null
        }
        setMattingOptLoading(false)
        setMattingOptOpen(false)
    }

    // 仅初次打开弹出示例图
    const [popoverOpen, setPopoverOpen] = useState(false)
    useEffect(() => {
        if (mattingOptOpen && !localStorage.getItem('popoverOpen') && imageType == IMAGE_TYPE.GLASSES_TRYON) {
            localStorage.setItem('popoverOpen', true)
            setPopoverOpen(true)
        }
        if (mattingOptOpen && !localStorage.getItem('popoverOpen2') && imageType == IMAGE_TYPE.SIM_TRYON) {
            localStorage.setItem('popoverOpen2', true)
            setPopoverOpen(true)
        }
    }, [mattingOptOpen, imageType])

    const mattingOptOpenCancle = () => {
        setMattingOptOpen(false)
        if (glassesTryonKeyList.length > 0 && !glassesTryonKeyList[0]?.attr?.foregroundAlphaMask) {
            setGlassesTryonKeyList([])
        }
        if (simTryonKeyList.length > 0 && !simTryonKeyList[0]?.attr?.foregroundAlphaMask) {
            setSimTryonKeyList([])
        }
    }

    const PopoverContent = (
        <div className={styles.glassesSample}>
            {
                imageType == IMAGE_TYPE.GLASSES_TRYON ?
                    <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/glassesResourceSample.png" alt="" /> :
                    <div className={styles.simSample}>
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample1.png" alt="" />
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample2.png" alt="" />
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample3.png" alt="" />
                    </div>
            }
            <p>{imageType == IMAGE_TYPE.GLASSES_TRYON ?
                '涂抹时，请完整覆盖模特的眼镜、耳朵和鼻梁；眼镜将佩戴在您标记的区域内' :
                '准确标记同版型的服装区域，效果会更好哦'}</p>
        </div>
    )


    // 是否是商品旧数据点了再次生成，此时要禁用侧边操作栏
    const CommidityOldDataRebuild = useMemo(() => {
        if (sceneKeyList.length == 0 || imageType != IMAGE_TYPE.COMMODITY) return false
        return sceneKeyList[0]?.attr?.commidityOldDataRebuild
    }, [sceneKeyList[0]?.attr?.commidityOldDataRebuild])

    const showCollapse = useMemo(() => {
        if (currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR || imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) return false
        return true
    }, [currentClothColorType, imageType])

    useEffect(() => {
        setOpen(false)
    }, [currentPoseFantasyMode])


    return (
        <>
            <div className={styles.leftComp}>
                <div
                    className={`${styles.FixedTop} _none_scrollbar ${CommidityOldDataRebuild ? styles.FixedTopDisabled : ''}`}
                    style={{ paddingBottom: bottomRef.current?.clientHeight }}>
                    {CommidityOldDataRebuild && <p>历史数据再次生成禁止编辑</p>}
                    <InputImageUploader />
                    {
                        showCollapse && <Collapse
                            ghost
                            expandIconPosition="end"
                            items={items}
                            defaultActiveKey={value}
                            activeKey={value}
                            expandIcon={expandIcon}
                            onChange={handleCollapseChange}
                        />
                    }
                    {showImgToVideoParams &&
                        <ImgToVideoParams
                            imageType={imageType}
                            drawerOpen={open}
                            resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO}
                            onDrawerOpen={() => handelOpenDrawer("prompt", RESOURCE_TYPE.IMAGE_TO_VIDEO)}
                            onDrawerClose={() => setOpen(false)} />}
                    {showResolution && <ResolutionSelectionWrap />}
                    {showGenerateMode && <GenerateMode />}
                    {showSkinRefine && <SkinRefine />}
                    {showRelight && <Relight imageType={imageType} />}
                    {showGenerateResolution && <SelectGenerateResolution />}
                    {showColorSelection &&
                        <ColorSelection
                            drawerOpen={open}
                            resourceType={RESOURCE_TYPE.COMMODITY_COLOR}
                            onDrawerOpen={() => handelOpenDrawer("collect", RESOURCE_TYPE.COMMODITY_COLOR)}
                            onDrawerClose={() => setOpen(false)}
                        />}
                    {(showClothColorSelection && showCollapse) &&
                        <ColorSelection
                            drawerOpen={open}
                            resourceType={RESOURCE_TYPE.CLOTH_RECOLOR}
                            onDrawerOpen={() => handelOpenDrawer("collect", RESOURCE_TYPE.CLOTH_RECOLOR)}
                            onDrawerClose={() => setOpen(false)}
                        />}
                </div>
                <div className={styles.FixedBottom} ref={bottomRef}>
                    {showNumSelect &&
                        <Select
                            value={generateNum}
                            options={[
                                { label: "1张", value: 1 },
                                { label: "2张", value: 2 },
                                { label: "3张", value: 3 },
                                { label: "4张", value: 4 },
                            ]}
                            labelRender={labelRender}
                            onChange={setGenerateNum}
                        />}
                    <Button
                        type="primary"
                        block
                        disabled={generateDisabled(imageType, generateContext) || isLoading}
                        loading={loading}
                        onClick={handleGenerate}
                    >
                        <div className={styles.GenerateBtn}>
                            <span>生成</span>
                            {generateDisabled(imageType, generateContext) || isLoading ?
                                <img src={require('@assets/images/arcbean3_disbaled.png')} /> :
                                <img src={require('@assets/images/arcbean3.png')} />}
                            <span>{costBean}</span>
                        </div>
                    </Button>
                </div>
            </div>
            <ReferSelectionDrawer
                value={drawerValue}
                open={open}
                onOpenChange={setOpen}
                defaultActiveKey={defaultActiveKey}
                customDisabled={customDisabled}
                resourceType={resourceType}
                multiple={multiple}
                imageType={imageType}
                onUpload={handleUpload}
                onChange={drawerOnChange}
                onMattingOpt={handleMattingOpt}
            />
            <UploadCustomMaterial
                ref={uploadCustomMaterialRef}
                handelOpenDrawer={handelOpenDrawer} />
            <PSAIModal
                title={
                    <>
                        {imageType == IMAGE_TYPE.GLASSES_TRYON ? '标记眼镜佩戴区域' : '编辑重绘区域'}
                        <Popover
                            trigger="click"
                            onOpenChange={(open) => setPopoverOpen(open)}
                            open={popoverOpen}
                            placement="rightTop"
                            content={PopoverContent}>
                            <InfoCircleOutlined style={{ marginLeft: '10px', cursor: 'pointer' }} />
                        </Popover>
                    </>
                }
                maxWidth={1380}
                closable={false}
                maskClosable={false}
                open={mattingOptOpen}
                confirmLoading={mattingOptLoading}
                okText="保存修改"
                cancelText="放弃修改"
                onCancel={mattingOptOpenCancle}
                onOk={handleMattingOptSave}
            >
                <div className={styles.MattingOptList}>
                    {
                        imageType == IMAGE_TYPE.GLASSES_TRYON ? (
                            mattingOptGroups.map((item, index) => (
                                <div key={index + IMAGE_TYPE.GLASSES_TRYON} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                    <MattingOptGlasses
                                        ref={ref => mattingOptRefs.current[index] = ref}
                                        imageType={imageType}
                                        blueMask={item.foregroundAlphaMask}
                                        whiteMask={item.binaryMask}
                                        inputImage={item.inputImage}
                                    />
                                </div>
                            ))
                        ) : (
                            mattingOptGroups.map((item, index) => (
                                <div key={index + IMAGE_TYPE.SIM_TRYON} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                    <MattingOptSimTryon
                                        ref={ref => mattingOptRefs.current[index] = ref}
                                        imageType={imageType}
                                        blueMask={item.foregroundAlphaMask}
                                        whiteMask={item.binaryMask}
                                        inputImage={item.inputImage}
                                        inputImageMultiSemanticId={item.semanticMaskId}
                                        inputImageMultiSemanticId2={item.semanticMaskId2}
                                        getMultiSemanticOutput={getMultiSemanticOutput}
                                        inputImageClothType={inputImageClothType}
                                    />
                                </div>
                            ))
                        )
                    }
                </div>
            </PSAIModal>
        </>
    )
}

export default LeftComp